import { Dispatch } from 'redux'
import { Prize } from '../reducers/spinWin.reducer'

export enum SpinWinActionTypes {
    FETCH_PRIZES_REQUEST = 'FETCH_PRIZES_REQUEST',
    FETCH_PRIZES_SUCCESS = 'FETCH_PRIZES_SUCCESS',
    FETCH_PRIZES_FAILURE = 'FETCH_PRIZES_FAILURE'
}

export interface FetchPrizesRequestAction {
    type: SpinWinActionTypes.FETCH_PRIZES_REQUEST
}

export interface FetchPrizesSuccessAction {
    type: SpinWinActionTypes.FETCH_PRIZES_SUCCESS
    data: Prize[]
}

export interface FetchPrizesFailureAction {
    type: SpinWinActionTypes.FETCH_PRIZES_FAILURE
    error: string
}

export type SpinWinActions =
    | FetchPrizesRequestAction
    | FetchPrizesSuccessAction
    | FetchPrizesFailureAction

// Change this URL when your real backend API is ready.
const PRIZES_API_URL = '/data/prizes.json'

export const fetchPrizes = () => async (dispatch: Dispatch) => {
    dispatch<FetchPrizesRequestAction>({
        type: SpinWinActionTypes.FETCH_PRIZES_REQUEST
    })

    try {
        const response = await fetch(PRIZES_API_URL, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        })

        if (!response.ok) {
            throw new Error(`Unable to fetch prizes (${response.status})`)
        }

        const data: Prize[] = await response.json()

        if (!Array.isArray(data)) {
            throw new Error('Invalid prizes response')
        }

        dispatch<FetchPrizesSuccessAction>({
            type: SpinWinActionTypes.FETCH_PRIZES_SUCCESS,
            data
        })

        return Promise.resolve<string>('Prizes fetched successfully')
    } catch (error) {
        const message =
            error instanceof Error ? error.message : 'Unable to fetch prizes'

        dispatch<FetchPrizesFailureAction>({
            type: SpinWinActionTypes.FETCH_PRIZES_FAILURE,
            error: message
        })

        return Promise.reject<string>(message)
    }
}